import { render } from "./importFile.vue?vue&type=template&id=32567b84"
import script from "./importFile.vue?vue&type=script&lang=js"
export * from "./importFile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__